// src/components/RequireAuth.jsx
// import { Navigate, Outlet, useLocation } from "react-router-dom";
// import { useAuth } from "../contexts/AuthContext";

// export default function RequireAuth({ children }) {
//   const { user, ready } = useAuth();
//   const loc = useLocation();

//   if (!ready) {
//     return <div className="p-6">Laddar…</div>;
//   }
  
//   if (!user) {
//     // const redirectTo = encodeURIComponent(loc.pathname + loc.search);
//     // return <Navigate to={`/auth?redirectTo=${redirectTo}`} replace />;
//     return <Navigate to="/auth" replace />
//   }

//   // När RootLayout skickas in som child:
//   return children ? children : <Outlet />;
// }

// src/components/RequireAuth.jsx
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { PageLoader } from "@/components/LoadingState";
import { NativeRouteSkeleton } from "@/components/skeletons/NativeLoadingSkeletons";
import { getNativePlatform } from "@/lib/runtime";

export default function RequireAuth({ children }) {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready) {
    if (getNativePlatform() === "android") {
      // Home owns its data-shaped skeleton. Avoid showing a second route skeleton first.
      return location.pathname === "/" ? <div className="min-h-screen bg-background" /> : <NativeRouteSkeleton />;
    }
    return <PageLoader />;
  }
  if (!user) {
    // return <Navigate to="/auth" replace state={{ from: location }} />;
    return <Navigate to="/auth" replace />;
  }
  
  return children ? children : <Outlet />;
}
